import React, { useState } from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  TextField,
  MenuItem
} from '@material-ui/core';
import { Formik } from 'formik';
import validations from 'src/utils/validations';
import { useLocation, useNavigate } from 'react-router';
import { Saluation } from 'src/__mocks__/leads';
import FirebaseApp, { Collections } from 'src/config/firebase.config';

const AddLeadDetails = (props) => {
  const navigate = useNavigate();
  const FirebaseDB = FirebaseApp.firestore();
  const { state } = useLocation();
  // const [submited, setSubmited] = useState(false)
  const [addedId, setAddedId] = useState("");

  console.info(state, addedId);

  return (
    <Formik
      initialValues={{
      }}
      validationSchema={validations.lead}
      {...props}
      onSubmit={(values) => {
        console.log("values", values);
        FirebaseDB.collection(Collections.Leads).add({
          ...values,
          createdAt: new Date(),
          id: state.id
        }).then((docRef) => {
          setAddedId(docRef.id)
          // navigate('/app/events', { replace: true });
        }).catch((e) => {
          alert(e.message);
        });
      }}
    >
      {({
        errors,
        handleBlur,
        handleChange,
        handleSubmit,
        isSubmitting,
        touched,
        values
      }) => (
        <form onSubmit={handleSubmit} autoComplete="off">
          <Card>
            <CardHeader
              subheader="The information can be edited"
              title="Add Lead"
            />
            <Divider />
            <CardContent>
              <Grid
                container
                spacing={3}
              >
                <Grid
                  item
                  md={6}
                  xs={12}
                >
                  <TextField
                    fullWidth
                    label="Select saluation"
                    name="saluation"
                    onChange={handleChange}
                    select
                    value={values.saluation}
                    variant="outlined"
                  >
                    {Saluation.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid
                  item
                  md={6}
                  xs={12}
                >
                  <TextField
                    error={Boolean(touched.title && errors.title)}
                    helperText={touched.title && errors.title}
                    fullWidth
                    label="Title"
                    name="title"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.title}
                    variant="outlined"
                  />
                </Grid>
                <Grid
                  item
                  md={5}
                  xs={12}
                >
                  <TextField
                    error={Boolean(touched.firstName && errors.firstName)}
                    helperText={touched.firstName && errors.firstName}
                    fullWidth
                    label="First name"
                    name="firstName"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.firstName}
                    variant="outlined"
                  />
                </Grid>
                <Grid
                  item
                  md={3}
                  xs={12}
                >
                  <TextField
                    error={Boolean(touched.lastName && errors.lastName)}
                    helperText={touched.lastName && errors.lastName}
                    fullWidth
                    label="Last name"
                    name="lastName"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.lastName}
                    variant="outlined"
                  />
                </Grid>
                <Grid
                  item
                  md={4}
                  xs={12}
                >
                  <TextField
                    error={Boolean(touched.firstName && errors.firstName)}
                    helperText={touched.firstName && errors.firstName}
                    fullWidth
                    label="Middle name"
                    name="middleName"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.middleName}
                    variant="outlined"
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                >
                  <TextField
                    error={Boolean(touched.email && errors.email)}
                    helperText={touched.email && errors.email}
                    fullWidth
                    label="Email"
                    name="email"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.email}
                    variant="outlined"
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                >
                  <TextField
                    error={Boolean(touched.address1 && errors.address1)}
                    helperText={touched.address1 && errors.address1}
                    fullWidth
                    label="Address 1"
                    name="address1"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.address1}
                    variant="outlined"
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                >
                  <TextField
                    error={Boolean(touched.address2 && errors.address2)}
                    helperText={touched.address2 && errors.address2}
                    fullWidth
                    label="Address 2"
                    name="address2"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.address2}
                    variant="outlined"
                  />
                </Grid>
                <Grid
                  item
                  md={5}
                  xs={12}
                >
                  <TextField
                    error={Boolean(touched.city && errors.city)}
                    helperText={touched.city && errors.city}
                    fullWidth
                    label="City"
                    name="city"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.city}
                    variant="outlined"
                  />
                </Grid>
                <Grid
                  item
                  md={4}
                  xs={12}
                >
                  <TextField
                    error={Boolean(touched.state && errors.state)}
                    helperText={touched.state && errors.state}
                    fullWidth
                    label="State"
                    name="state"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.state}
                    variant="outlined"
                  />
                </Grid>
                <Grid
                  item
                  md={3}
                  xs={12}
                >
                  <TextField
                    error={Boolean(touched.zip && errors.zip)}
                    helperText={touched.zip && errors.zip}
                    fullWidth
                    label="Zip"
                    name="zip"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.zip}
                    variant="outlined"
                  />
                </Grid>
                <Grid
                  item
                  md={6}
                  xs={12}
                >
                  <TextField
                    error={Boolean(touched.phone && errors.phone)}
                    helperText={touched.phone && errors.phone}
                    fullWidth
                    label="Phone Number"
                    name="phone"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.phone}
                    variant="outlined"
                  />
                </Grid>
                <Grid
                  item
                  md={6}
                  xs={12}
                >
                  <TextField
                    error={Boolean(touched.cellPhone && errors.cellPhone)}
                    helperText={touched.cellPhone && errors.cellPhone}
                    fullWidth
                    label="Cell Phone"
                    name="cellPhone"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.cellPhone}
                    variant="outlined"
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                >
                  <TextField
                    error={Boolean(touched.notes && errors.notes)}
                    helperText={touched.notes && errors.notes}
                    fullWidth
                    label="Notes"
                    name="notes"
                    onBlur={handleBlur}
                    multiline
                    rows={4}
                    onChange={handleChange}
                    value={values.notes}
                    variant="outlined"
                  />
                </Grid>
              </Grid>
            </CardContent>
            <Divider />
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                p: 2
              }}
            >
              {_.isEmpty(addedId) ? (
                <Button
                  color="primary"
                  disabled={isSubmitting}
                  onClick={handleSubmit}
                  type="submit"
                  variant="contained"
                >
                  Save details
                </Button>
              ) : (
                <Button
                  onClick={() => navigate(`/app/addQuestion/${addedId}`)}
                  type="button"
                  variant="text"
                >
                  Complete Questions
                </Button>
              )}
            </Box>
          </Card>
        </form>
      )}
    </Formik>
  );
};
export default AddLeadDetails;
